module.exports = __webpack_public_path__ + "reset.3b4c5513.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/friends/reset.svg
// module id = ./src/images/friends/reset.svg
// module chunks = main